module.exports = __webpack_public_path__ + "static/media/herring.bf5b3494.jpg";